module.exports = __webpack_public_path__ + "img/img3.2b683548.jpg";